import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

const EMPTY = { current: "", next: "", confirm: "" };
const FIELDS = [["current", "Current password"], ["next", "New password (min 8 characters)"], ["confirm", "Confirm new password"]];

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.next.length < 8) return setError("New password must be at least 8 characters");
    if (form.next !== form.confirm) return setError("New passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password changed");
      setForm(EMPTY);
      setOpen(false);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setError(""); setForm(EMPTY); }}>
      <DialogTrigger asChild>
        <Button variant="ghost" data-testid="change-password-open-btn"><KeyRound className="mr-1 h-4 w-4" /><span className="hidden sm:inline">Password</span></Button>
      </DialogTrigger>
      <DialogContent className="max-w-md" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Change password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {FIELDS.map(([k, label]) => (
            <div key={k} className="space-y-2">
              <Label htmlFor={`pw-${k}`}>{label}</Label>
              <Input id={`pw-${k}`} type="password" className="h-11" value={form[k]} required autoComplete={k === "current" ? "current-password" : "new-password"}
                onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`change-password-${k}-input`} />
            </div>
          ))}
          {error && <p className="text-sm text-destructive" data-testid="change-password-error">{error}</p>}
          <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="change-password-submit-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Update password
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
